import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined'
import MonochromePhotosOutlinedIcon from '@mui/icons-material/MonochromePhotosOutlined'
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined'
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined'
import AccessAlarmOutlinedIcon from '@mui/icons-material/AccessAlarmOutlined'

export default function RaceCardActions ({ race, happeningNow, ended }) {
  const { t } = useTranslation('races')
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        justifyContent: 'center',
        mt: 'auto',
        [theme.breakpoints.only('sm')]: {
          flexDirection: 'column',
          '& .MuiButton-root': {
            width: '100%'
          }
        },
        [theme.breakpoints.only('md')]: {
          flexDirection: 'column',
          '& .MuiButton-root': {
            width: '100%'
          }
        },
        [theme.breakpoints.only('lg')]: {
          flexDirection: 'column',
          '& .MuiButton-root': {
            width: '100%'
          }
        }
      })}
    >
      {race.status === 'open' &&
        <Button
          component={Link}
          to={`/races/${race.slug}/registration`}
          variant='contained'
          color='primary'
          sx={{ minWidth: 100 }}
        >
          <HowToRegOutlinedIcon fontSize='small' />&nbsp;
          {t('actions.register')}
        </Button>}

      {happeningNow && !ended &&
        <Button
          component={Link}
          to={`/races/${race.slug}/live`}
          variant='outlined'
          color='icon'
          sx={{ minWidth: 100 }}
        >
          <AccessAlarmOutlinedIcon fontSize='small' />&nbsp;
          {t('actions.viewLiveResults')}
        </Button>}

      {ended &&
        <Button
          component={Link}
          to={`/races/${race.slug}/results`}
          variant='outlined'
          color='icon'
          sx={{ minWidth: 100 }}
        >
          <FormatListNumberedOutlinedIcon fontSize='small' />&nbsp;
          {t('actions.viewResults')}
        </Button>}
      {ended && race.showMedia &&
        <Button
          component={Link}
          to={`/races/${race.slug}/media`}
          variant='outlined'
          color='icon'
          sx={{ minWidth: 100 }}
        >
          <MonochromePhotosOutlinedIcon fontSize='small' />&nbsp;
          {t('actions.viewMedia')}
        </Button>}
      {!(ended || happeningNow) &&
        <Button
          component={Link}
          to={`/races/${race.slug}/details`}
          variant='outlined'
          color='icon'
          sx={{ minWidth: 100 }}
        >
          <EmojiEventsOutlinedIcon fontSize='small' />&nbsp;
          {t('actions.viewEvent')}
        </Button>}
    </Box>
  )
}
